//accounting reports - converted to lazy loading
const AccountingTree = () => import('@/pages/accounting/accountingTree/index.vue')
const Test = () => import('@/pages/test.vue')
// Accounting restrictions - converted to lazy loading
const AccountingRestrictions = () => import('@/pages/accounting/accountingRestrictions/index.vue')
const AccountingRestrictionsForm = () =>
  import('@/pages/accounting/accountingRestrictions/form.vue')
const AccountingRestrictionsShow = () =>
  import('@/pages/accounting/accountingRestrictions/show.vue')
// Auto transactions - converted to lazy loading
const AutoRestrictions = () => import('@/pages/accounting/autoRestrictions/index.vue')
const AutoRestrictionsForm = () => import('@/pages/accounting/autoRestrictions/form.vue')
const AutoRestrictionsShow = () => import('@/pages/accounting/autoRestrictions/show.vue')

// Cost centers - converted to lazy loading
const CostCenters = () => import('@/pages/accounting/costCenter/index.vue')
const CostCentersForm = () => import('@/pages/accounting/costCenter/form.vue')

// reports - converted to lazy loading
const trialBalance = () => import('@/pages/accounting/trialBalance.vue')
const reviewBalance = () => import('@/pages/accounting/reviewBalance.vue')
const incomeStatement = () => import('@/pages/accounting/incomeStatement.vue')
const totalAccounts = () => import('@/pages/accounting/totalAccounts.vue')
const profitsByInvoices = () => import('@/pages/accounting/profitsByInvoices.vue')

// Settings - converted to lazy loading
const accountingSettings = () => import('@/pages/accounting/accountingSettings/index.vue')
const accountingRouting = () =>
  import('@/pages/accounting/accountingSettings/accountingRouting.vue')

// account balance
const accountBalances = () => import('@/pages/accounting/accountBalances/form.vue')

// rent - converted to lazy loading
const rent = () => import('@/pages/accounting/rent/index.vue')
const rentForm = () => import('@/pages/accounting/rent/form.vue')
const rentShow = () => import('@/pages/accounting/rent/show.vue')
const mainAccountStatements = () => import('@/pages/accounting/mainAccountStatement.vue')

const routes = [
  {
    path: 'test',
    name: 'test',
    component: Test
  },
  {
    path: 'totalAccounts',
    name: 'totalAccounts',
    component: totalAccounts
  },
  {
    path: 'mainAccountStatements',
    name: 'mainAccountStatements',
    component: mainAccountStatements
  },
  {
    path: 'accountingTree',
    name: 'accountingTree',
    component: AccountingTree
  },
  {
    path: 'accountingRestrictions',
    name: 'accountingRestrictions',
    component: AccountingRestrictions
  },
  {
    path: 'accountingRestrictions/create',
    name: 'accountingRestrictionsCreate',
    component: AccountingRestrictionsForm
  },
  {
    path: 'accountingRestrictions/:id',
    name: 'accountingRestrictionsShow',
    component: AccountingRestrictionsShow
  },
  {
    path: 'accountingRestrictions/:id/edit',
    name: 'accountingRestrictionsEdit',
    component: AccountingRestrictionsForm
  },
  {
    path: 'autoRestrictions',
    name: 'autoRestrictions',
    component: AutoRestrictions
  },
  {
    path: 'autoRestrictions/create',
    name: 'autoRestrictionsCreate',
    component: AutoRestrictionsForm
  },
  {
    path: 'autoRestrictions/:id',
    name: 'autoRestrictionsShow',
    component: AutoRestrictionsShow
  },
  {
    path: 'autoRestrictions/:id/edit',
    name: 'autoRestrictionsEdit',
    component: AutoRestrictionsForm
  },
  {
    path: 'costCenters',
    name: 'costCenters',
    component: CostCenters
  },
  {
    path: 'costCenters/create',
    name: 'CostCentersCreate',
    component: CostCentersForm
  },
  {
    path: 'costCenters/:id/edit',
    name: 'CostCentersEdit',
    component: CostCentersForm
  },
  {
    path: 'profitsByInvoices',
    name: 'profitsByInvoices',
    component: profitsByInvoices
  },
  {
    path: 'accountingSettings',
    name: 'accountingSettings',
    component: accountingSettings
  },
  {
    path: 'accountingSettings/accountingRouting',
    name: 'accountingRouting',
    component: accountingRouting
  },
  {
    path: 'accountBalances',
    name: 'accountBalances',
    component: accountBalances
  },
  { path: 'trialBalance', name: 'trialBalance', component: trialBalance },
  { path: 'reviewBalance', name: 'reviewBalance', component: reviewBalance },
  { path: 'incomeStatement', name: 'incomeStatement', component: incomeStatement },
  { path: 'rent', name: 'rent', component: rent },
  { path: 'rent/create', name: 'rentCreate', component: rentForm },
  { path: 'rent/:id', name: 'rentShow', component: rentShow },
  { path: 'rent/:id/edit', name: 'rentEdit', component: rentForm }
]

export default routes
